import React from 'react';
import CustomFileUpload from "./CustomFileUpload";

const UploadReportPDF = ({ userId, error, file, handleFileSelect, selectedFile }) => {

  return (
    <div>
      <CustomFileUpload userId={userId} file={file} selectedFile={selectedFile} handleFileSelect={handleFileSelect} />
      <div className="output">
        {error && <div>{error}</div>}
        {/* {file && <div>{file.name}</div>} */}
      </div>
    </div>
  );
}

export default UploadReportPDF;